/* CDX Card-Slider — Pfeil-Buttons (wie Galerie) statt Scrollbar.
   Greift für .acc-grid, .ups-grid, .serie-highlights innerhalb .cdx-pdp-sec. */
(function () {
  if (window.__cdxSliderRefresh) { window.__cdxSliderRefresh(); return; }

  var SEL = '.cdx-pdp-sec .acc-grid, .cdx-pdp-sec .ups-grid, .cdx-pdp-sec .serie-highlights, .cdx-pdp-sec .cdx-cseo-rg-track';
  var updaters = [];

  function initSlider(track) {
    if (track.__cdxSlider) return;
    track.__cdxSlider = true;

    var wrap = document.createElement('div');
    wrap.className = 'cdx-slider';
    track.parentNode.insertBefore(wrap, track);
    wrap.appendChild(track);

    function mkBtn(dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cdx-slider__nav cdx-slider__nav--' + dir;
      b.setAttribute('aria-label', dir === 'prev' ? btT('cdx_slider.prev', 'Zurück') : btT('cdx_slider.next', 'Weiter'));
      b.innerHTML = '<svg class="cdx-ic"><use href="#ui-arrow-' + (dir === 'prev' ? 'left' : 'right') + '"/></svg>';
      return b;
    }
    var prev = mkBtn('prev'), next = mkBtn('next');
    wrap.appendChild(prev); wrap.appendChild(next);

    function step() { return Math.max(track.clientWidth * 0.85, 220); }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      wrap.classList.toggle('has-nav', track.scrollWidth > track.clientWidth + 4);
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }
    track.addEventListener('scroll', update, { passive: true });
    updaters.push(update);
    update();
  }

  function refresh() {
    document.querySelectorAll(SEL).forEach(initSlider);
    updaters.forEach(function (u) { u(); });
  }
  window.__cdxSliderRefresh = refresh;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();
  document.addEventListener('cdx:slider-refresh', refresh);
  window.addEventListener('resize', refresh);
})();
